"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenChatQueryParamOnMount = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _webMessengerContext = require("../contexts/webMessengerContext");
const DELAY = 500;

/** Runs openChatWindow with a delay when `openChat` query param is `true` and script is loaded. */
const useOpenChatQueryParamOnMount = () => {
  const {
    openChatWindow
  } = (0, _webMessengerContext.useWebMessenger)();
  const actionExecuted = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    const openChatAsString = (0, _presentationUtils.getClientQueryParam)('openChat');
    const openChat = openChatAsString === 'true';
    if (!actionExecuted.current && openChat) {
      const timeoutId = setTimeout(() => {
        openChatWindow();
        actionExecuted.current = true;
      }, DELAY);
      return () => clearTimeout(timeoutId);
    }
    return () => {};
  }, [openChatWindow]);
};
exports.useOpenChatQueryParamOnMount = useOpenChatQueryParamOnMount;
